import React from 'react';

/** Divider block — horizontal rule. */
export default function Divider() {
  return (
    <div className="max-w-6xl mx-auto px-6" data-testid="site-block-divider">
      <hr className="my-12 orka-border-subtle border-0 border-t" />
    </div>
  );
}
